import { parse } from "date-fns";
import { DateRange } from "react-day-picker";
import { IEsimPackage, ILocationZone } from "../../interfaces/esim/EsimPackages.types";
import RangePicker from "../ui/datepicker/range/RangePicker";
import { LocationZoneSelector } from "./LocationZoneSelector";
import { PackageSelector } from "./PackageSelector";
import { SourceChannelSelector } from "./SourceChannelSelector";

interface DashboardFiltersProps {
  from: string | null | undefined;
  to: string | null | undefined;
  search: string;
  setSearch: (value: string) => void;
  locationZones: ILocationZone[];
  selectedZone: ILocationZone | null;
  packages: IEsimPackage[];
  selectedPackage: IEsimPackage | null;
  isInputFocused: boolean;
  setIsInputFocused: (value: boolean) => void;
  packagesLoading: boolean;
  selectedSourceChannel: string | null;
  onDateApply: (r: DateRange | undefined) => void;
  onZoneSelect: (zone: ILocationZone) => void;
  onZoneClear: () => void;
  onPackageSelect: (packageItem: IEsimPackage | null) => void;
  onSourceChannelSelect: (channel: string | null) => void;
}

export const DashboardFilters: React.FC<DashboardFiltersProps> = ({
  from,
  to,
  search,
  setSearch,
  locationZones,
  selectedZone,
  packages,
  selectedPackage,
  isInputFocused,
  setIsInputFocused,
  packagesLoading,
  selectedSourceChannel,
  onDateApply,
  onZoneSelect,
  onZoneClear,
  onPackageSelect,
  onSourceChannelSelect
}) => {
  return (
    <div className="flex flex-col lg:flex-row lg:items-center mb-4 gap-4">
      <div className="flex flex-col sm:flex-row sm:items-center lg:flex-1 relative z-40">
        <label className="mb-2 sm:mb-0 sm:mr-2 text-sm font-medium text-gray-700
          whitespace-nowrap">Zona:</label>
        <div className="w-full sm:w-64 lg:w-full">
          <LocationZoneSelector search={search} setSearch={setSearch}
            selectedZone={selectedZone} locationZones={locationZones}
            isInputFocused={isInputFocused} setIsInputFocused={setIsInputFocused}
            onZoneSelect={onZoneSelect} onZoneClear={onZoneClear} />
        </div>
      </div>
      <div className="flex flex-col sm:flex-row sm:items-center lg:flex-1 relative z-30">
        <label className="mb-2 sm:mb-0 sm:mr-2 text-sm font-medium text-gray-700
          whitespace-nowrap">Paketa:</label>
        <div className="w-full sm:w-64 lg:w-full">
          <PackageSelector packages={packages} selectedPackage={selectedPackage}
            onPackageSelect={onPackageSelect} loading={packagesLoading}
            disabled={!selectedZone} />
        </div>
      </div>
      <div className="flex flex-col sm:flex-row sm:items-center lg:flex-1 relative z-20">
        <label className="mb-2 sm:mb-0 sm:mr-2 text-sm font-medium text-gray-700
          whitespace-nowrap">Burimi:</label>
        <div className="w-full sm:w-64 lg:w-full">
          <SourceChannelSelector value={selectedSourceChannel}
            onChange={onSourceChannelSelect} />
        </div>
      </div>
      <div className="flex flex-col sm:flex-row sm:items-center lg:flex-1">
        <label className="mb-2 sm:mb-0 sm:mr-2 text-sm font-medium text-gray-700
          whitespace-nowrap">Filtro datën:</label>
        <div className="w-full sm:w-64 lg:w-full">
          <RangePicker className="flex flex-row items-center w-full"
            range={from && to ? {
              from: parse(from, "dd/MM/yyyy", new Date()),
              to: parse(to, "dd/MM/yyyy", new Date())
            } : undefined}
            pickerProps={{ toDate: new Date() }} hasHelpers={true}
            onApply={onDateApply} />
        </div>
      </div>
    </div>
  );
};
